var shpCustom = {

	cartItemsCountPanel: ".shpCartCount",
	cartItemsValuePanel: ".shpCartValue",

	shpProduct: null,
	shpCart: null,
	reloadEnabled: false,
	twoLevelZoom: false,
	
	baseURL: '',
	shpCountryISO: '',
	cookieInfoPeriod: 0,
	newsletterDismiss: 0,
	newsletterSubmit: 0,

  moneyFormat: '',
  amountFormat: '',

  currentGridSize: '',
	
//##################################################################################################
//	INITIALIZATION
//##################################################################################################
	init: function() {
		shpCustom.baseURL 					= $('meta[name="shpBaseDir"]').attr('content');
		shpCustom.shpCountryISO 		= $('meta[name="shpCountryISO"]').attr('content');
		shpCustom.cookieInfoPeriod 	= $('meta[name="shpCookieInfoPeriod"]').attr('content');
		shpCustom.newsletterDismiss = $('meta[name="shpNewsletterDismiss"]').attr('content');
		shpCustom.newsletterSubmit 	= $('meta[name="shpNewsletterSubmit"]').attr('content');
		
	//-------------------------------------------------------------------------------------------------	
	//	money format
	//-------------------------------------------------------------------------------------------------	
  shpCustom.moneyFormat = shpTheme.money.moneyFormat+"";
  shpCustom.amountFormat = shpCustom.moneyFormat.match(/\{\{amount(.*)\}\}/g)
  
  //-------------------------------------------------------------------------------------------------	
	//	cart
	//-------------------------------------------------------------------------------------------------	
		$(document).off('click', '.shpAdd2CartButton').on('click', '.shpAdd2CartButton', function(event) {
			event.preventDefault();
			event.stopPropagation();
			shpCustom.cartItemAdd(this);
		});
		$('.shpAdd2CartButton').removeClass('d-none');

		shpCustom.initCartEvents();

		if (sessionStorage.getItem("shpShowCart")) {
			setTimeout(shpCustom.showCart(),1000);
		}

		
	//-------------------------------------------------------------------------------------------------	
	//	misc
	//-------------------------------------------------------------------------------------------------	
		// blog, collections
		$('#shpLoadItemsList').off('click').on('click', function(event) {
			event.preventDefault();
			shpCustom.loadItemsList($(this).attr("href"));
		});
		
		// magic with open modals, change href
		this.hrefToModal();
		$('button[data-target]').on('click', function() {
			location.href = $(this).data('target');
		});
		$('#shpCustomShowInfo').on('hidden.bs.modal', function(){ 
			$(this).find(".modal-title").text('');
			$(this).find(".modal-body").html('');	
		})

		// scroll2Element
		$('[data-scroll2element]').on('click', function(event) {
			event.preventDefault();
			shpCustom.scrollToElement($(this).data('scroll2element'));
		});

		// copy current URL to clipboard
		// show info about it
		$('[data-clipboard-share]').on('click', function(event) {
			event.preventDefault();
			let copyText = location.href;
			if (copyText) {
				 navigator.clipboard.writeText(copyText);
				 shpCustom.showInfo($(this).data('clipboard-share'), copyText);
			}
		});
		
		// checkbox group with only one ON
		$('[data-checkbox_group]').on('change', function(event) {
			event.preventDefault();
			shpCustom.chceckboxGroup($(this));
		});

	//-------------------------------------------------------------------------------------------------	
	// check newsletter box
	//-------------------------------------------------------------------------------------------------	
		if (!shpCustom.getCookie('newsletter_box')) {
			$('#shpNewsletterModalPanel').on('hidden.bs.modal', function(event) {
				if (shpCustom.newsletterDismiss>0) {
					shpCustom.setCookie('newsletter_box',1, shpCustom.newsletterDismiss);	// close Newsletter window for X days
				} else {
					shpCustom.setCookie('newsletter_box',1);			// close Newsletter window for current session
				}
			})
			setTimeout(function(){
				$('#shpNewsletterModalPanel').modal('show');
			}, 2000);
		}	
		$('.shpCustomNewsletterFormDiv form').on('submit', function() {	// if submited any newsletter form
			if (shpCustom.newsletterSubmit>0) {
				shpCustom.setCookie('newsletter_box',1, shpCustom.newsletterSubmit);	// close Newsletter window for X days
			} else {
				shpCustom.setCookie('newsletter_box',1);			// close Newsletter window for current session
			}
		}); 
		
		
	//-------------------------------------------------------------------------------------------------	
	// check Cookie information
	//-------------------------------------------------------------------------------------------------	
		if (!shpCustom.getCookie('cookies_box')) {
			$('#shpCookiesModalPanel button.accept').on('click', function() {
				$('#shpCookiesModalPanel').addClass('d-none');
				if (shpCustom.cookieInfoPeriod>0) {
					shpCustom.setCookie('cookies_box',1, shpCustom.cookieInfoPeriod);	// close Cookie information for X days
				} else {
					shpCustom.setCookie('cookies_box',1);			// close Cookie information for current session
				}
			});
			$('#shpCookiesModalPanel').removeClass('d-none');
		}
		

	//-------------------------------------------------------------------------------------------------	
	//	customer section
	//-------------------------------------------------------------------------------------------------	
		//if ($('body.login-page').length>0) {
			// login / password reset-start
			$('.shpLoginFormToggle').on('click', function(event) {
				event.preventDefault();
				$('.shpLoginForm').toggle();
			});
		//}
		
		if ($('body.addresses-page').length>0) {
			// addresses
			// show/hide address form
			$('[data-target_item_form_id]').on('click', function(event) {
				event.preventDefault();
				$('[data-item_form_id]').hide();
				let form_id = $(this).data('target_item_form_id');
				$('[data-item_form_id='+form_id+']').show();
			});
			// confirm address removal
			$('#shpAddressRemoveConfirmation').on('show.bs.modal', function (event) {
				var button = $(event.relatedTarget);
				$(this).find('form').attr('action',button.data('target'))
			});
			$('#shpAddressRemoveConfirmation').on('hidden.bs.modal', function (event) {
				$(this).find('form').attr('action','#');
			});

			$('select[name="address[country]"]').each(function () {
				shpCustom.setSelectValue($(this));
			})
		}

	//-------------------------------------------------------------------------------------------------	
	//	collection page / product list
	//-------------------------------------------------------------------------------------------------	
		if ($('body.collection-page').length>0) {
			
			// filters
			$('#filters button.apply').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyFilters();
			});
			
			$('#filters').on('click', 'button.reset, .filter-chips .clear-filters', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyFilters(true);
			});

			$('#filters').on('click', '.filter-chips a:not(.clear-filters)', function(event) {
				event.preventDefault();
				shpCustom.removeChipFilter($(this).attr('href'));
			});

			// tag-filters
			$('#tag-filters button.apply').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagFilters();
			});
			
			$('#tag-filters button.reset').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagFilters(true);
			});

			if ($('#tag-filters').data('start_mode') == 'background') {
				$('#tag-filters input[type=checkbox], input[type=radio]').on('click', function(event) {
					shpCustom.applyTagFilters();
				});
			}
			
			shpCustom.initApplyFilters();

		}
		
	//-------------------------------------------------------------------------------------------------	
	//	search page
	//-------------------------------------------------------------------------------------------------	
		if ($('body.search-page').length>0) {
			
			let query = shpCustom.getUrlParameter('q');
			if (query) {
				jQuery.each(query.split(/[\+\,\;]/), function(index, element) {
					//console.log('|'+element+'|');
					$('#tag-filters').find('input[type=checkbox][data-name="'+element.trim()+'"]').prop("checked",true);
				});
			}			
			
			// filters
			$('#filters button.apply').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyFilters();
			});
			
			$('#filters button.reset').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyFilters(true);
			});

			// tag-filters
			$('#tag-filters button.apply').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagSearchFilters();
			});
			
			$('#tag-filters button.reset').on('click', function(event) {
				event.preventDefault();
				shpCustom.reloadEnabled = true;
				shpCustom.applyTagSearchFilters(true);
			});
			
			shpCustom.initApplyFilters();

		}
		
	//-------------------------------------------------------------------------------------------------	
	//	product page
	//-------------------------------------------------------------------------------------------------	
		if ($('body.product-page').length>0) {
			
			shpCustom.reloadEnabled = true;
			let product_handle = $('#product-object').data('handle');
			jQuery.getJSON("/products/"+product_handle+".js", function(product) {
				shpCustom.shpProduct = product;
				shpCustom.add2Visited(product);
				// get selected Variant ID
				shpCustom.shpProduct.selected_variant_id = $('#product-object').data('variant');
				jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
					if (element.id == shpCustom.shpProduct.selected_variant_id) {
						// get selected Variant position
						shpCustom.shpProduct.selected_variant_index = index;
					}
				});
				$('body').trigger('updateProductInfo');
			});

			shpCustom.initSwatchSelectors();

      shpCustom.initVariantSelectors();

		};
		
	//-------------------------------------------------------------------------------------------------	
	//	video with mobile sources
	//-------------------------------------------------------------------------------------------------	
		$( window ).on( "resize", function() {
			let w = window.innerWidth
							|| document.documentElement.clientWidth
							|| document.body.clientWidth;
      let newCurrentSize;
      if (w >= 1400)      { newCurrentSize = 'xxl'; } 
      else if (w >= 1200) { newCurrentSize = 'xl';  } 
      else if (w >= 992)  { newCurrentSize = 'lg';  }
      else if (w >= 768)  { newCurrentSize = 'md';  }
      else if (w >= 576)  { newCurrentSize = 'sm';  }
      else                { newCurrentSize = 'xs';  }

      if (newCurrentSize != shpCustom.currentGridSize) {
        var e = jQuery.Event( "gridSizeChange", { 
          currentSize: newCurrentSize,
          previousSize: shpCustom.currentGridSize  
        } );
        shpCustom.currentGridSize = newCurrentSize;
        $(window).trigger(e);
      }

			$("video[data-mobile]").each(function () {
				// change SRC for mobile
				if ($(this).children('source').data('mobile') != undefined && w <= 768) {
					if ($(this).children('source').data('mobile') != $(this).children('source').attr('src')) {
						$(this).children('source').attr('src', $(this).children('source').data('mobile'));
						$(this)[0].load();
					}
				} else if ($(this).children('source').data('desktop') != undefined) {
					if ($(this).children('source').data('desktop') != $(this).children('source').attr('src')) {
						$(this).children('source').attr('src', $(this).children('source').data('desktop'));
						$(this)[0].load();
					}
				}
			});
		});
		$( window ).trigger('resize');

		//-------------------------------------------------------------------------------------------------	
		//	simple variant switch
		//-------------------------------------------------------------------------------------------------	
		$('[data-variant_simple_selector]').on('click', function(event) {
			//event.preventDefault();
			//event.stopPropagation();
			shpCustom.varaintSimpleSwitch(this);
		});
	
		//-------------------------------------------------------------------------------------------------	
		//	ui-groups
		//	(a group of checkboxes controlling hidden inputs)
		//-------------------------------------------------------------------------------------------------	
		$('[data-ui_group]').on('change', function(event) {	
			event.preventDefault();
			shpCustom.uiGroupRun(this);
		});

		window.shpCustom = shpCustom;
	},
	
//##################################################################################################
//	module functions
//##################################################################################################

	show: function(element) {
		$(element).get(0).style.removeProperty("display");
	},

	hide: function(element) {
		$(element).hide();
	},

  formatMoney: function(amount) {
    let numeralFormat;
    if (shpCustom.amountFormat == '{{amount}}') {
      numeralFormat = '0,0.00'
    } else if (shpCustom.amountFormat == '{{amount_no_decimals}}') {
      numeralFormat = '0,0'
    } else if (shpCustom.amountFormat == '{{amount_with_period_and_space_separator}}') {
      numeralFormat = '0 0.00'
    }
    return shpCustom.moneyFormat.replace(shpCustom.amountFormat, numeral(amount).format(numeralFormat));
  },

//-------------------------------------------------------------------------------------------------	
//	cookies
//-------------------------------------------------------------------------------------------------	
	setCookie: function (cname, cvalue) {
		var expires = "";
		var path = "path=/";
		if (arguments[2]) {
			var d = new Date();
			d.setTime(d.getTime() + (arguments[2]*24*60*60*1000));
			expires = "expires="+d.toGMTString()+"; ";
		}
		document.cookie = "SHP_" + cname + "=" + cvalue + "; " + expires + path;
	},
	
	getCookie: function (cname) {
		var name = "SHP_" + cname + "=";
		var ca = document.cookie.split(';');
		for(var i=0; i<ca.length; i++) {
			var c = ca[i].trim();
			if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
		}
		return "";
	},
	
	
//-------------------------------------------------------------------------------------------------	
//	misc
//-------------------------------------------------------------------------------------------------	

	// change a.href with href #modal_id (added in Theme Customization) to button witch opens that modal
	hrefToModal: function() {
		$('.modal').each(function () {
			let id = $(this).attr("id");
			$("a[href='#"+id+"']").each(function () {
				$(this).attr('href','#');
				$(this).attr('data-bs-toggle','modal').data('bs-toggle','modal');
				$(this).attr('data-bs-target','#'+id).data('bs-target','#'+id);
			});
		});
	},
	
	/**
	 *  @brief Loads next page of items. Should be bined to <a href="url2load"> button
	 *  
	 *  @param [in] url2load 					url to load next page (href)
	 *  @param [in] successCallback 	callback function
	 *  @param [in] clearContainer 		flag: clear Items container before load?
	 *  
	 *  @details 
	 *  	- items are placed in #shpItemsList2Load-container (next are append to old one)
	 *  	- panel with loading - #shpItemsList2Load-count (old panel content is replaced by next)
	 *  
	 */
	loadItemsList: function(url2load) {
		$('body').addClass('shpItemsLoading');
		let successCallback = (arguments[1]) ? arguments[1] : "";
		let clearContainer = (arguments[2]) ? arguments[2] : "";
		$.ajax({
			url: url2load,
			type: 'GET'
		}).done(function (data) {
			// 1. load itemsList into page
			if (clearContainer) {
				$('#shpItemsList2Load-container').html($(data).find('#shpItemsList2Load-container').html());
			} else {
				$('#shpItemsList2Load-container').append($(data).find('#shpItemsList2Load-container').html());
			}
			// 2. refresh itemsListCount
			$('#shpItemsList2Load-count').html($(data).find('#shpItemsList2Load-count').html());

			// 3. attach loadItemsList method
			$('#shpLoadItemsList').off('click').on('click', function(event) {
				event.preventDefault();
				shpCustom.loadItemsList($(this).attr("href"), successCallback, clearContainer);
			});
			
			// 4. run callback
			if (typeof successCallback !== 'function') {
				successCallback = false;
			}
			if (successCallback) {
				successCallback(data);
			}
			
			// 5. Show add to cart buttons for newly loaded items
			$('#shpItemsList2Load-container .shpAdd2CartButton').removeClass('d-none');
			
			$('body').removeClass('shpItemsLoading');
			$('body').trigger('loadItemsList');
		});
	},
		
	getUrlParameter: function(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === sParam) {
				return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
			}
    }
    return false;
	},
	
	setSelectValue: function(selectElement) {
		let selectValue = $(selectElement).data('default');
		if (selectValue) {
			$(selectElement).find('option').each(function() {
				if ($(this).text() == selectValue) {
					$(this).prop('selected',true);
					return false;
				}
			});
		}
	},
	
	showInfo: function (infoTitle, infoText, do_reload) {
		if ($('#shpCustomShowInfo').length>0) {
			let infoModal = $('#shpCustomShowInfo');
			$(infoModal).find(".modal-title").text(infoTitle);
			$(infoModal).find(".modal-body").html(infoText);	
      if (do_reload) {
        $(infoModal).one('hidden.bs.modal', event => {
          window.location.reload();
        })
      }
      $(infoModal).modal('show');
		} else {
			alert(infoTitle + ':' + String.fromCharCode(13,10) + infoText);
      if (do_reload) {
        window.location.reload();
      }
		}
	},
	
	scrollToElement: function(elSelector) {
		if ($(elSelector).length>0) {
			let position = $(elSelector).position();
			let headerOffset = ($("header").length > 0 ? $("header").height() : 0);
			let marginHeight = 5;
			
			position = parseInt(position.top ) - headerOffset - marginHeight;
			document.body.scrollTop = position; // For Safari
			document.documentElement.scrollTop = position; // For Chrome, Firefox, IE and Opera
		}
	},
	
	uiGroupRun: function(element) {		
		if ($('[data-ui_group="'+  $(element).data('ui_group') +'"]').length>1) {
			let mainElement = $('[data-ui="'+  $(element).data('ui_group') +'"]');
			let mainValue = ($(element).prop('checked') ? $(element).val() : '');
			if ($(mainElement).length > 0) {
				$(mainElement).val(mainValue);
				$('[data-ui_group="'+  $(element).data('ui_group') +'"]').each(function() {
					$(this).prop('checked', ($(this).val() == mainValue));
				});
				$(mainElement).change();
			}
		}
	},

	gotoURL: function(element) {
		location.href = encodeURI($(element).data('url'));
	},

	isInViewport: function(el) {
    const rect = el.getBoundingClientRect();
		let result = {
			'top': rect.top >= 0,
			'left': rect.left >= 0,
			'bottom': rect.bottom <= (window.innerHeight || document.documentElement.clientHeight),
			'right': rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		};
		//console.log(result, rect);
    return (result.top && result.left && result.bottom && result.right );
	},

	isOverViewport: function(el) {
    const rect = el.getBoundingClientRect();
		let result = {
			'top': rect.top <= 0
		};
		//console.log(result, rect);
    return (result.top);
	},


	

//-------------------------------------------------------------------------------------------------	
//	collection page / product list
//-------------------------------------------------------------------------------------------------	

	initApplyFilters: function() {
    //$('#filters button.apply').off('click')
    //$('#filters button.reset').off('click')

		$('#filters button.apply').one('click', function(event) {
			event.preventDefault();
			shpCustom.reloadEnabled = true;
			shpCustom.applyFilters();
		});
		
		$('#filters button.reset').one('click', function(event) {
			event.preventDefault();
			shpCustom.reloadEnabled = true;
			shpCustom.applyFilters(true);
		});

		if ($('#filters').data('start_mode') == 'background') {
      //$('#filters input[type=checkbox], input[type=radio]').off('change')
			$('#filters input[type=checkbox], input[type=radio]').one('change', function(event) {
				event.preventDefault();
				shpCustom.applyFilters();
			});
		}
	},

	/**
	 *  @brief function to assign submit (read filter checkboxes, send request and get response)
	 */
	applyFilters: function() {

		let filtersPanel = $('#filters');
		let targetUrl = '';
		
		if (filtersPanel.data('collection_url')) {		

			let collectionURL = shpCustom.baseURL + filtersPanel.data('collection_url') + '/';
			let filtersList = [];

			let paramsURL = filtersPanel.data('url_params');
			if (paramsURL) {
				filtersList.push(paramsURL);
			}
			

			if (arguments[0] !== true) {// true => reset filters
				// filters are defined by checkbox inside filtersPanel
				filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
					if ($(this).attr('name')!='sort_by' && $(this).prop('checked') && $(this).prop('disabled')==false) {
						filtersList.push($(this).attr('name')+'='+encodeURI($(this).val()));
					}
				});
			} else {
				filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
					$(this).prop('checked', false);
				});
			}

			if (filtersPanel.data('collection_sortby')) {
				// sorting is defined elsewhere
				filtersList.push('sort_by='+filtersPanel.data('collection_sortby'));
			} else {
				// sorting is defined by checkbox inside filtersPanel
				if (arguments[0] !== true) {// true => reset sorting
					let sort_order = filtersPanel.find('input[name=sort_by]:checked').val();
					if (sort_order) {
						filtersList.push('sort_by='+sort_order);
					}
				}
			}	
			targetUrl = collectionURL
			if (filtersList.length > 0) {
				targetUrl = targetUrl + '?' + filtersList.join('&');
			}


			if (filtersPanel.data('run_mode') == 'reload' && shpCustom.reloadEnabled) {
				window.location.href = targetUrl;
			} else if (filtersPanel.data('run_mode') == 'ajax') {
				// update URL (without reloading)
				history.pushState('page', 'Collection page', targetUrl);

				// update filters panel 
				$.ajax({
					url: targetUrl + ( targetUrl == collectionURL ? '?' : '&') + 'sections=api-collection-filters',
					type: 'GET'
				}).done(function(data) {
					// 1. load into page elements signed data-filter_item2load='element_index'
					$(data['api-collection-filters']).find('[data-filter_item2load]').each(function() {
						if ($(this).data('filter_item2load')) {
							$('#filters').find('[data-filter_item2load="' + $(this).data('filter_item2load') + '"]').html($(this).html());
							$('#filters').find('[data-filter_item2load="' + $(this).data('filter_item2load') + '"]').attr('class', $(this).attr('class'));
						}
					});
					shpCustom.initApplyFilters()
				});

				// load items list
				shpCustom.loadItemsList(targetUrl, false, true);
			}
		}
		return targetUrl;
	},

		/**
	 *  @brief function to remove chip filter
	 */
	removeChipFilter: function (chipFilter) {
		let filtersPanel = $('#filters');
		if (!chipFilter || !filtersPanel.length) {
			return '';
		}

		let chipUrl = new URL(chipFilter, window.location.origin);
		let chipParams = chipUrl.searchParams;
		let checkedMap = {};

		chipParams.forEach(function(value, key) {
			if (!checkedMap[key]) {
				checkedMap[key] = [];
			}
			checkedMap[key].push(value);
		});

		// Rebuild filter UI from chip URL, then reuse applyFilters for consistent Ajax/update behavior.
		filtersPanel.find('input[type=checkbox], input[type=radio]').each(function() {
			let input = $(this);
			let name = input.attr('name');
			let inputValue = String(input.val());
			let shouldCheck = false;

			if (checkedMap[name] && checkedMap[name].indexOf(inputValue) > -1) {
				shouldCheck = true;
			}

			input.prop('checked', shouldCheck);
		});

		shpCustom.reloadEnabled = true;
		return shpCustom.applyFilters();
	},

	/**
	 *  @brief function to assign submit (read tag checkboxes and send request)
	 */
	applyTagFilters: function() {
		let filtersPanel = $('#tag-filters');
		let targetUrl = '';
		
		if (filtersPanel.data('collection_url')) {		

			let collectionURL = shpCustom.baseURL + filtersPanel.data('collection_url') + '/';
			let filtersList = [];
			let sort_url = '';
			
			if (arguments[0] !== true) {// true => reset filters
				let externalFilters = false;
			
				let filterDataset = filtersPanel.data();
				//console.log(filterDataset);
				if (filterDataset != undefined) {
					for (const property in filterDataset) {
						if (property.substring(0,17) == 'collection_filter') {
							// filters are defined elsewhere and kept in filtersPanel.data()
							externalFilters = true;
							if (filterDataset[property] != '') {
								filtersList.push(filterDataset[property]);
							}
						}	
					}
				}
				
				if (!externalFilters) {
					// filters are defined by checkbox inside filtersPanel
					filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
						if ($(this).attr('name')!='sort_by' && $(this).prop('checked') && $(this).prop('disabled')==false) {
							filtersList.push($(this).val());
						}
					});
				}
			} else {
				filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
					$(this).prop('checked', false);
				});
			}

			if (filtersPanel.data('collection_sortby')) {
				// sorting is defined elsewhere
				sort_url = '?sort_by='+filtersPanel.data('collection_sortby');
			} else {
				// sorting is defined by checkbox inside filtersPanel
				if (arguments[0] !== true) {// true => reset sorting
					let sort_order = filtersPanel.find('input[name=sort_by]:checked').val();
					if (sort_order) {
						sort_url = '?sort_by='+sort_order;
					}
				}
			}
		
			//console.log(collectionURL + filtersList.join('+') + sort_url);
			targetUrl = collectionURL + filtersList.join('+') + sort_url;

			if (filtersPanel.data('run_mode') == 'reload' && shpCustom.reloadEnabled) {
				window.location.href = targetUrl;
			} else if (filtersPanel.data('run_mode') == 'ajax') {
				// update URL (without reloading)
				history.pushState('page', 'Collection page', targetUrl);
				shpCustom.loadItemsList(targetUrl, false, true);
			}
		}
		return targetUrl;
	},

//-------------------------------------------------------------------------------------------------	
//	search page
//-------------------------------------------------------------------------------------------------	

	applyTagSearchFilters: function() {
		let filtersPanel = $('#tag-filters');
		let targetUrl = '';
		
		if (filtersPanel.data('collection_url')) {		

			let searchURL = shpCustom.baseURL + filtersPanel.data('collection_url');
			let paramsList = [];

			let sort_url = '';
			if (filtersPanel.data('collection_sortby')) {
				// sorting is defined elsewhere
				sort_url = 'sort_by='+filtersPanel.data('collection_sortby').trim();
			} else {
				// sorting is defined by checkbox inside filtersPanel
				if (arguments[0] !== true) {// true => reset sorting
					let sort_order = filtersPanel.find('input[name=sort_by]:checked').val();
					if (sort_order) {
						sort_url = 'sort_by='+sort_order.trim();
					}
				}
			}
			if (sort_url) {
				paramsList.push(sort_url);
			}
			
			if (filtersPanel.data('search_type')) {
				paramsList.push('type='+filtersPanel.data('search_type').trim());
			}
			
			let filtersList = [];
			if (filtersPanel.data('search_q')) {
				filtersList.push(filtersPanel.data('search_q').trim());
			}
			if (arguments[0] !== true) {// true => reset filters (but only TAGS)
				
				let externalFilters = false;			
				let filterDataset = filtersPanel.data();
				//console.log(filterDataset);
				if (filterDataset != undefined) {
					for (const property in filterDataset) {
						if (property.substring(0,17) == 'collection_filter') {
							// filters are defined elsewhere and kept in filtersPanel.data()
							externalFilters = true;
							if (filterDataset[property] != '') {
								filtersList.push(filterDataset[property]);
							}
						}	
					}
				}
				
				if (!externalFilters) {
					// filters are defined by checkbox inside filtersPanel
					filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
						if ($(this).attr('name')!='sort_by' && $(this).prop('checked') && $(this).prop('disabled')==false) {
							filtersList.push($(this).val());
						}
					});
				}
			} else {
				filtersPanel.find('input[type=checkbox], input[type=radio]').each(function(index) {
					$(this).prop('checked', false);
				});
			}
			paramsList.push('q=' + filtersList.join('+'));
			
			targetUrl = searchURL + '?' + paramsList.join('&')

			if (filtersPanel.data('run_mode') == 'reload' && shpCustom.reloadEnabled) {
				window.location.href = targetUrl;
			} else if (filtersPanel.data('run_mode') == 'ajax') {
				// update URL (without reloading)
				history.pushState('page', 'Search result', targetUrl);
				shpCustom.loadItemsList(targetUrl, false, true);
			}
		}
		return targetUrl;
	},
			
//-------------------------------------------------------------------------------------------------	
//	product
//-------------------------------------------------------------------------------------------------	

	initVariantSelectors: function() {
		// many variants selectors (based on CHECKBOXES)
		$('input.variantSelector').one('click', function() {
			let cartForm = $(this).parents('form');
			let newVariantID = $(this).val();
			let currentID = $(this).attr('id');
			
			$(cartForm).find('input.variantSelector').each(function () {
				if ($(this).val()==newVariantID && $(this).attr('id') != currentID) {
					$(this).prop('checked',true);
				}
			})
			jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
				if (element.id == newVariantID) {
					shpCustom.updateVariantInfo(element);
				}
			});				
		});
		
		// one variant selector (based on SELECT)
		$('select.variantSelector').one('change', function() {
			let cartForm = $(this).parents('form');
			let newVariantID = $(this).find('option:selected').val();
			let currentID = $(this).attr('id');
			
			jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
				if (element.id == newVariantID) {
					shpCustom.updateVariantInfo(element);
				}
			});
		});

		// set selectors (based on SELECT)
		$('select.setSelector').one('change', function() {
			let target = $(this).val();
			if (target && target != '#') {
				window.location.href = shpCustom.baseURL + $(this).val();
			}
		});
	},

  initSwatchSelectors: function() {
    // productgroup selector (SWATCH)
    $('input[name=productgroup]').one('change', function() {
      let target = $(this).val();
      if (target && target != '#') {
        window.location.href = shpCustom.baseURL + $(this).val();
      }
    });
	},

	/**
	 * @brief	switching variants implemented as controlling the visibility of already prepared elements
	 *				suitable for simple elements, panels
	 */
	varaintSimpleSwitch: function(element) {
		let container = $(element).parents('[data-variant_simple_container]');
		let variant_id = $(element).data('variant_id');

		if (container.length>0 && variant_id != undefined) {
			$(container).find('[data-variant_simple_selector]').removeClass('active');
			$(element).addClass('active');

			$(container).find('[data-selected_variant_id]').addClass('d-none');
			$(container).find('[data-selected_variant_id='+variant_id+']').removeClass('d-none');

			jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
				if (element.id == variant_id) {
					if (element.available) {
						$(container).find('[data-selected_variant_notavailable]').addClass('d-none');
						$(container).find('[data-selected_variant_available]').removeClass('d-none');
					} else {
						$(container).find('[data-selected_variant_available]').addClass('d-none');
						$(container).find('[data-selected_variant_notavailable]').removeClass('d-none');
					}
				}
			});
		}
	},

	/**
	 * @brief	reloading to variant page 
	 *				variant idetyfication based on options list
	 */
	reload2Variant: function (option1, option2, option3) {			
		
		let goodID_123 = null;	
		let goodID_12 = null;	
		
		let firstOption1ID = null;
		let firstOption2ID = null;
		let firstOption3ID = null;

		let selectedVariant = shpCustom.shpProduct.variants[shpCustom.shpProduct.selected_variant_index];
		jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
			if (!firstOption1ID && element.options[0] == option1) {
				firstOption1ID = element.id;
			}
			if (!firstOption2ID && element.options[1] == option2) {
				firstOption2ID = element.id;
			}
			if (!firstOption3ID && element.options[2] == option3) {
				firstOption3ID = element.id;
			}

			if (!goodID_12 && element.options[0] == option1 && element.options[1] == option2) {
				goodID_12 = element.id;
			}
			if (!goodID_123 && element.options[0] == option1 && element.options[1] == option2 && element.options[2] == option3) {
				goodID_123 = element.id;
			}
		});
		
		let goodID = ( goodID_123 ? goodID_123 : goodID_12);
		
		if (!goodID) {
			if (firstOption1ID) {
				goodID = firstOption1ID;
			} else if (firstOption2ID) {
				goodID = firstOption2ID;
			} else {
				goodID = firstOption3ID;
			}
		}			
		if (goodID) {
			//if (shpCustom.reloadEnabled) {
				window.location.href = shpCustom.baseURL + shpCustom.shpProduct.url + '?variant=' + goodID;
			//}
		}
	},

	/**
	 *  @brief from changed option calculate new selected Variant
	 *  
	 *  @param [in] optionID		option.position
	 *  @param [in] optionValue option value for Variant
	 *  @return slected Variant Object
	 *  
	 */
	setNewVariantByOptions: function(optionID, optionValue) {
		let newVariant = false;
		let currentVariant = shpCustom.shpProduct.variants[shpCustom.shpProduct.selected_variant_index];
		let currentFeatures = {
			"option1": null, "option2": null, "option3": null
		};
		if (currentVariant) {
			currentFeatures = {
				"option1": currentVariant.option1,
				"option2": currentVariant.option2,
				"option3": currentVariant.option3
			};
		}
		// get clone of currentFeatures but with changed option
		let newFeatures = Object.assign({}, currentFeatures);
		newFeatures[optionID] = optionValue;
		
		jQuery.each(shpCustom.shpProduct.variants, function(index, element) {
			if (element.option1 == newFeatures.option1 && element.option2 == newFeatures.option2 && element.option3 == newFeatures.option3) {
				newVariant = Object.assign({}, element);
				newVariant['index'] = index;
			}
		});
		
		shpCustom.updateVariantInfo(newVariant);
	},

	/**
	 *  @brief load data of new Variant into HTML Elements (JS OR Section Rendering API)
	 *  
	 *  @param [in] newVariant 	new variant data
	 */
	updateVariantInfo: function(newVariant) {
		const mode = $('#product-object').data('variant_switch');
		
		if (newVariant != false) {
			// variant ID
			$('#product-object').attr('data-variant',newVariant.id).data('variant',newVariant.id);
			$('#product-object input[name=id]').val(newVariant.id);
			let sellingPlan = ''
			
			if (mode == 'section-load') { // loading newVariant using Section AJAX API
				if ($('#product-object input[name=selling_plan]').val() != '') {
					sellingPlan = '&selling_plan=' + $('#product-object input[name=selling_plan]').val();
				}
				$.ajax({
					url: $('#product-object').data('baseurl') + '?sections=main-product&variant=' + newVariant.id + sellingPlan,
					type: 'GET'
				}).done(function(data) {
					// 1. load html into page
					$('#shpProductVariant-container').html($(data['main-product']).find('#shpProductVariant-container').html());
					shpCustom.initSwatchSelectors();
					shpCustom.initVariantSelectors();

					shpCustom.shpProduct.selected_variant_id = newVariant.id;
					history.pushState('page', shpCustom.shpProduct.title, $('#product-object').data('baseurl') + '?variant=' + newVariant.id);
					$('body').trigger('updateVariantInfo');
				});

			} else { // loading a newVariant by updating predefined elements based on data in the newVariant object
			
				// price
				$('#product-object .product-standard-price').html(shpCustom.formatMoney(newVariant.price/100));
				if (newVariant.compare_at_price > newVariant.price) {
					$('#product-object .product-compare-price').html(shpCustom.formatMoney(newVariant.compare_at_price/100));
				} else {
					$('#product-object .product-compare-price').html('');
				}
				
				// AddToCart buttons
				let Add2Cart = $('#product-object .shpAdd2CartButton');
				if (newVariant.available) {
					$(Add2Cart).prop("disabled",false);
					$(Add2Cart).find('[data-unavailable_label]').hide();
					$(Add2Cart).find('[data-add2cart_label]').show();
					//$(Add2Cart).find('[data-add2cart_label]').html(shpTheme.strings.addToCart);
				} else {
					$(Add2Cart).prop("disabled",true);
					$(Add2Cart).find('[data-add2cart_label]').hide();
					$(Add2Cart).find('[data-unavailable_label]').show();
					//$(Add2Cart).find('[data-add2cart_label]').html(shpTheme.strings.unavailableProduct);
				}
				
				shpCustom.shpProduct.selected_variant_id = newVariant.id;
				history.pushState('page', shpCustom.shpProduct.title, $('#product-object').data('baseurl') + '?variant=' + newVariant.id);
				$('body').trigger('updateVariantInfo');
			}

		} else {
			shpCustom.showInfo(shpTheme.strings.unknownVariantTitle, shpTheme.strings.unknownVariantMessage);
		}
	},

	add2Visited: function(product) {
		const productData = {
			productID: product.id,
			title: product.title,
			handle: product.handle
		};

		const productList = [];
		let jsonResp, jsonRespArr, jsonRespArrStr;
		const numberOfProducts = 20;
	
		productList.push(productData);
		const currProductPageTitle = productData.title;
		const productDataString = JSON.stringify(productList);
		const localData = localStorage.getItem("recentlyViewedProduct");
	
	  if (localData === null) {
			localStorage.setItem("recentlyViewedProduct", productDataString);
		} else if (localData) {
			const oldProductData = localStorage.getItem("recentlyViewedProduct");
			const countProductData = (oldProductData.match(/productID/g) || []).length;
			const sameProduct = oldProductData.includes(currProductPageTitle);
	
			if (countProductData < numberOfProducts && sameProduct == false) {
				jsonResp = JSON.parse(oldProductData);
				jsonRespArr = jsonResp.concat(productList);
				jsonRespArrStr = JSON.stringify(jsonRespArr);
				localStorage.setItem("recentlyViewedProduct", jsonRespArrStr);
			} else if (countProductData >= numberOfProducts && sameProduct == false) {
				jsonResp = JSON.parse(oldProductData);
				jsonResp.shift();
				jsonRespArr = jsonResp.concat(productList);
				jsonRespArr = JSON.stringify(jsonRespArr);
				localStorage.setItem("recentlyViewedProduct", jsonRespArr);
			}
		}
	},


//-------------------------------------------------------------------------------------------------	
//	cart
//-------------------------------------------------------------------------------------------------	
	/**
	 * @brief	initialization of the operation of the main elements of the shopping cart interface
	 */
	initCartEvents: function() {
		// cart lines
    $('[data-cart-item-quantity_group] [data-type=minus]').off('click')
    $('[data-cart-item-quantity_group] [data-type=plus]').off('click')
    $('[data-cart-item-quantity_group] [data-type=remove]').off('click')
    $('[data-cart-item-quantity_group] [data-cart-item-quantity]').off('change')
    $('[data-cart-item-selling_plan]').off('change')
    $('[data-cart-attribute]').off('change')
    $('[data-cart-note]').off('change')

		$('[data-cart-item-quantity_group] [data-type=minus]').on('click', function(event) {
			event.preventDefault();
			shpCustom.setQuantity(this, -1);
		});
		$('[data-cart-item-quantity_group] [data-type=plus]').on('click', function(event) {
			event.preventDefault();
			shpCustom.setQuantity(this, 1);
		});
		$('[data-cart-item-quantity_group] [data-type=remove]').on('click', function(event) {
			event.preventDefault();
			shpCustom.cartItemRemove(this);
		});
		// Cart Page Remove button
		$('.cart [data-type=remove]').off('click').on('click', function(event) {
			event.preventDefault();
			shpCustom.cartItemRemove(this);
		});
		$('[data-cart-item-quantity_group] [data-cart-item-quantity]').on('change', function(event) {
			event.preventDefault();
			let productSection = $(this).parents('[data-cart-item]');
			shpCustom.cartItemUpdate(productSection.data('cart-item-key'), $(this).val());		
		});
		$('[data-cart-item-selling_plan]').on('change', function(event) {
			event.preventDefault();
			let productSection = $(this).parents('[data-cart-item]');
			shpCustom.cartItemUpdate(productSection.data('cart-item-key'), null, $(this).val());		
		});

		// cart properties
		$('[data-cart-attribute]').on('change', function(event) {
			event.preventDefault();
			shpCustom.cartAttributeUpdate(this);
		});
		$('[data-cart-note]').on('change', function(event) {
			event.preventDefault();
			shpCustom.cartUpdate($(this).val(), null);
		});
	},

	showCart: function() {
		$('body').trigger('shpShowCart');
		sessionStorage.removeItem("shpShowCart");
	},

	getCart: function() {
		let silentMode = (arguments[0] === true);
		jQuery.getJSON("/cart.js", function(cart) {
			shpCustom.shpCart = cart;
			shpCustom.updateCartInfo();
			$('.shpProcessCartWait').hide();
			if (!silentMode) {
				shpCustom.showCart();
			}
		});
	},

	updateCartInfo: function(showCart) {

		if (Object.hasOwn(shpCustom.shpCart, 'sections') && Object.hasOwn(shpCustom.shpCart.sections, 'api-cart_content')) {
			$('.shpCartContent').html($(shpCustom.shpCart.sections['api-cart_content']).html());
			shpCustom.initCartEvents();
		}

		// update summary data
		$(shpCustom.cartItemsCountPanel).text(shpCustom.shpCart.item_count);
		$(shpCustom.cartItemsValuePanel).html(shpCustom.formatMoney(shpCustom.shpCart.total_price/100));
		
		// update cart status
		if (shpCustom.shpCart.item_count==0) {
			$('.shpCartContent').addClass('empty');
		} else {
			$('.shpCartContent').removeClass('empty');
		}

		$('body').trigger('updateCartInfo');

		if (showCart) {
			shpCustom.showCart();
		}		
	},

	setQuantity: function(element, step) {
		let sectionContainer = $(element).parents('[data-cart-item-quantity_group]');
		if (!$(sectionContainer).hasClass('section-disabled')) {
			let sectionInput
      console.log(sectionContainer, $(sectionContainer).find('input[name="quantity"]').length)
			if ($(sectionContainer).find('input[name="quantity"]').length > 0) {
				sectionInput = $(sectionContainer).find('input[name="quantity"]');
			} else if ($(sectionContainer).find('input[name="updates[]"]').length > 0) {
				sectionInput = $(sectionContainer).find('input[name="updates[]"]');
			} else if ($(sectionContainer).find('input[name="updates_foo[]"]').length > 0) {
				sectionInput = $(sectionContainer).find('input[name="updates_foo[]"]');
			}

			if (sectionInput && sectionInput.length > 0) {
				let result = $(sectionInput).val()*1 + step*1;
				if (result*1 <= 0) {
					result = 1;
				}

        if (sectionContainer.data('cart-item-quantity_group') != "") {
          let ciqg = sectionContainer.data('cart-item-quantity_group')
          $('[data-cart-item-quantity_group='+ciqg+']').find('input[name="quantity"],input[name="updates[]"],input[name="updates_foo[]"]').each(function() {
            $(this).val(result)
          })
        } else {
          $(sectionInput).val(result);
        }
				
				if (result<=1) {
					$(sectionContainer).find('[data-type=minus]').prop("disabled", true);
				}	else {
					$(sectionContainer).find('[data-type=minus]').prop("disabled", false);
				}

				if (result < 10) {
					result = "0" + result;
				}

        if ($(element).parents('[data-cart-item]').length > 0) {
          // CART update - only 4 Dynamic Cart
          shpCustom.cartItemUpdate($(element).parents('[data-cart-item]').data('cart-item-key'), result);
        }
              
        $(sectionContainer).find('[data-cart-item-quantity_label]').text(result);
        
			}

		}
	},
	
	cartItemRemove: function(element) {
		let productSection = $(element).closest('[data-cart-item], [data-level]');
		let lineKey = productSection.data('cart-item-key');
		shpCustom.cartItemUpdate(lineKey, 0, null, null, productSection);
	},

	cartItemAdd: function (element) {
		let parent_id, variant_id, variant_quantity, selling_plan, do_reload, gift_upsell_checked, gift_upsell_id;
		let properties = {};
		
		if ($(element).data('variant_id') != undefined) {
			// all data are attached to AddToBag button (product list case)
			variant_id = $(element).data('variant_id');
			variant_quantity = ($(element).data('quantity') != undefined ? $(element).data('quantity') : 1);
			selling_plan = $(element).data('selling_plan');
			do_reload = ($(element).data('reload') != undefined && $(element).data('reload'));
			
			if ($(element).data('item_property') != undefined) {
				let property = $(element).data('item_property').split('|');
				properties[property[0]] = property[1];
			}
			
		} else {
			// all data are attached to parent form (product page case)
			let cartForm = $(element).parents('form');
			variant_id = $(cartForm).find('input[name="id"]').val();
			variant_quantity = $(cartForm).find('input[name="quantity"]').val();
			selling_plan = $(cartForm).find('input[name="selling_plan"]').val();
			gift_upsell_id = $(cartForm).find('input[name="gift-upsell-id"]');
			gift_upsell_checked = $(cartForm).find('input[name="gift-upsell"]:checked');
			
			$(cartForm).find('input[name^="properties"]').each(function () {
				if ($(this).val()) {
					let text = $(this).attr('name');
					let propertyName = text.substr(0,text.length-1).replace("properties[","");
					properties[propertyName] = $(this).val();
				}
			})

			if (gift_upsell_checked?.val()) { properties['Attached'] = gift_upsell_id.data('gift-title'); }
		}
		
		$('.shpProcessCartWait').show();		 
		$(element).prop('disabled', true);

		let items = [{
			id: variant_id,
			quantity : variant_quantity || 1,
			selling_plan: selling_plan,
			properties: properties,
		}]

		if (gift_upsell_checked?.val()) {
			items.push({
				id: gift_upsell_id.val(),
				quantity: variant_quantity || 1,
				parent_id: variant_id
			})
		}

		jQuery.ajax({
			type: "POST",
			url: "/cart/add.js",
			data: JSON.stringify({
				items: items,
				sections: 'api-cart_content,api-cart_summary'
			}),
			dataType: "json",
			contentType: "application/json",
			success: function (success_data) {
				shpCustom.shpCart = success_data;
				if (do_reload) {
					// if cart should be shown AFTER reload
					sessionStorage.setItem("shpShowCart", true);
					window.location.reload();					
				} else {
					if (shpCustom.shpCart) {
						shpCustom.shpCart['sections'] = success_data['sections'];
					} else {
						shpCustom.shpCart = {
							'sections': success_data['sections']
						}
					}
					let dataSet = $(shpCustom.shpCart.sections['api-cart_summary']).find('#cart_summary').data();
					for (const key in dataSet) {
						if (dataSet.hasOwnProperty(key)) {
							shpCustom.shpCart[key] = dataSet[key]
						}
					}
					shpCustom.updateCartInfo(true);
				}
				$('.shpProcessCartWait').hide();
			},
			error: function (error_data, error_type) {
				shpCustom.cartUpdateError(error_data);
			},
			complete: function () {
				$(element).prop('disabled',false);
				$(element).data('adding-to-cart', false);
				if (gift_upsell_checked) $(gift_upsell_checked).prop('checked', false);
			}
		});
	},
		
	cartItemUpdate: function (line_key, new_quantity, new_selling_plan, new_properties, productSection) {
		let data2change = {id: line_key, sections: 'api-cart_content'}
		if (new_quantity !== null) {
      new_quantity = new_quantity * 1
			data2change['quantity'] = new_quantity;
		}
		if (new_selling_plan !== null) {
			data2change['selling_plan'] = new_selling_plan;
		}
		if (new_properties !== null) {
			data2change['properties'] = new_properties;
		}
		$('.shpProcessCartWait').show();
		
    // on CART page - reload is mandatory
    let do_reload = ($('body.cart-page').length>0)

		jQuery.ajax({
			type: "POST",
			url: "/cart/change.js",
			data: data2change,
			dataType: "json",
			success: function (success_data) {
				shpCustom.shpCart = success_data;

				if (!do_reload) {
          if (new_quantity==0) {
            $('[data-cart-item-key="'+line_key+'"]').remove();
          } else if (success_data.items) {
            // check if update succeded
            $.each(success_data.items, function( index, item ) {
              if (line_key == item.key) {
                if (new_quantity > item.quantity) {
                  shpCustom.showInfo(shpTheme.strings.cartUpdateUnsuccessful, shpTheme.strings.productInventoryLevelTooLow);
                }								
              }
            });
          }
          $('.shpProcessCartWait').hide();
        }
				
				shpCustom.updateCartInfo();
			},
			error: function (error_data, error_type) {
				shpCustom.cartUpdateError(error_data);
			},
			complete: function () {
				const parentId = productSection?.data('cart-item-parent-id');
				if (parentId) {
					let parentItemExists = false;
					let existingProperties = {};
					if (shpCustom.shpCart && shpCustom.shpCart.sections['api-cart_content']) {
						let cartContent = $(shpCustom.shpCart.sections['api-cart_content']);
						parentItemExists = cartContent.find('[data-cart-item-variant_id="' + parentId + '"]').length > 0;

						if (shpCustom.shpCart.items.length > 0) {
							existingProperties = shpCustom.shpCart.items.find(item => item.id === parentId)?.properties || {};
							if (existingProperties['Attached'] !== undefined) {
								delete existingProperties['Attached'];
							}
						}
					}
			
					if (parentItemExists) {
						shpCustom.cartItemUpdate(parentId, null, null, {
							...existingProperties,
							'_UnAttached': 'gift item removed from cart'
						});
						return;
					}
				}

				if (do_reload) {
					window.location.reload();
        }
			}
		});
	},

	cartAttributeUpdate: function(element) {
		let elementValue;
		if (element != undefined && !$(element).data('disable_events')) {
			let elementName = $(element).attr('name');
			let elementForm = $(element).parents('form');
			//console.log(elementForm)
			if ($(element).attr('type') == 'checkbox' || $(element).attr('type') == 'radio') {
				elementValue = $('[name="'+elementName+'"]:checked').val();
			} else {
				elementValue = $('[name="'+elementName+'"]').val();
			}

			let attributes = {};
			$(elementForm).find('[data-cart-attribute]').each(function () {
				let thisName = $(this).attr('name');
				let thisValue;

				if ($(this).attr('type') == 'checkbox' || $(this).attr('type') == 'radio') {
					thisValue = $(elementForm).find('[name="'+thisName+'"]:checked').val();
				} else {
					thisValue = $(elementForm).find('[name="'+thisName+'"]').val();
				}
				if (thisValue != undefined && thisValue != "") {
					attributes[$(this).data('cart-attribute')] = thisValue;
				} else {
					attributes[$(this).data('cart-attribute')] = null;
				}
			});

			jQuery.ajax({
				type: "POST",
				url: "/cart/update.js",
				data: {
					attributes: attributes,
					sections: 'api-cart_content'
				},
				dataType: "json",
				success: function (success_data) {
					shpCustom.shpCart = success_data;
					shpCustom.updateCartInfo();
					$('.shpProcessCartWait').hide();
				},
				error: function (error_data, error_type) {
					shpCustom.cartUpdateError(error_data);
				},
				complete: function () {
          // nothing
				}
			});
	
		}
	},
	
	cartUpdate: function(cart_note, cart_attributes) {

		let data2change = {sections: 'api-cart_content'}
		if (cart_note !== null) {
			data2change['note'] = cart_note;
		}
		if (cart_note !== null) {
			data2change['attributes'] = cart_attributes;
		}

		jQuery.ajax({
			type: "POST",
			url: "/cart/update.js",
			data: data2change,
			dataType: "json",
			success: function (success_data) {
				shpCustom.shpCart = success_data;
				shpCustom.updateCartInfo();
				$('.shpProcessCartWait').hide();
			},
			error: function (error_data, error_type) {
				shpCustom.cartUpdateError(error_data);
			},
			complete: function () {
        // nothing
			}
		});
	},
	
	cartUpdateSuccess: function(success_data, sucess_info) {
	},

	cartUpdateError: function(error_data) {
		let error_info = error_data.responseJSON
    // Cart Error - must be reload
		shpCustom.showInfo(error_info.message, error_info.description, true);
	},

//-------------------------------------------------------------------------------------------------	
//	other
//-------------------------------------------------------------------------------------------------	
	calculateFS: function () {
		console.log('calculateFS')

		$('[data-free_shipment]').each(function () {
			let fsObj = $(this);
			let fsObjLevel = fsObj.find('[data-free_shipment_level]');
			let fsObjCountry = fsObjLevel.data('free_shipment_country');
	
			if (fsObjLevel.data('free_shipment_level') != undefined && fsObjLevel.data('free_shipment_level') > 0 &&
				$('[data-cart-subtotal]').attr('data-cart-subtotal') != undefined && $('[data-cart-subtotal]').attr('data-cart-subtotal')>=0) {

				let cart_value = $('[data-cart-subtotal]').attr('data-cart-subtotal')*1
				if (fsObjLevel.data('free_shipment_virtual')*1 > 0) {
					cart_value = cart_value + fsObjLevel.data('free_shipment_virtual')*1
				}

				let left_2_free_shipment = fsObjLevel.data('free_shipment_level') - cart_value;
				
				let info, percentage;
				if (left_2_free_shipment > 0) {
					if (fsObj.data('free_shipment_missing') != '' && Object.hasOwn(shpTheme.strings, fsObj.data('free_shipment_missing'))) {
						info = shpTheme.strings[fsObj.data('free_shipment_missing')]+"";
					} else {
						info = shpTheme.strings.free_shipment_missing+"";
					}
					info = info.replace('{{value}}', shpCustom.formatMoney(left_2_free_shipment));
					
					percentage = Math.round(100*(cart_value / fsObjLevel.data('free_shipment_level')));

					fsObj.removeClass('free_shipping_achieved')
					
				} else {
					if (fsObj.data('free_shipment_unlocked') != '' && Object.hasOwn(shpTheme.strings, fsObj.data('free_shipment_unlocked'))) {
						info = shpTheme.strings[fsObj.data('free_shipment_unlocked')]+"";
					} else {
						info = shpTheme.strings.free_shipment_unlocked+"";
					}
					info = info.replace('{{value}}', shpCustom.formatMoney(fsObjLevel.data('free_shipment_level')));
					percentage = 100

					fsObj.addClass('free_shipping_achieved')
				}
				info = info.replace('{{country}}', fsObjCountry);
				fsObjLevel.html(info);

				fsObj.find('[data-progress-container]').attr('aria-valuenow', percentage)
				fsObj.find('[data-progress-bar]').attr('style', 'width:'+ percentage+'%')
			} else {
				fsObj.hide();
			}


		});		
	},

	initSellingPlanElements: function () {
		if ($('#product-object input[name=selling_plan]').val() == '' && $('.subscribe[data-default-plan-id]').length > 0) {
			$('#product-object input[name=selling_plan]').val($('.subscribe[data-default-plan-id]').data('default-plan-id'));
		}

		$('.shpAdd2CartButton [data-default-price]').each(function() {
			if ($('#subscribe .single-offer.active .plan-price').length>0) {
				let current_plan_price = $('#subscribe .single-offer.active .plan-price')
				$(this).html(current_plan_price.html())
				$(this).attr('data-current_price_value', current_plan_price.data('value')).data('current_price_value', current_plan_price.data('value'))
			}
			$('[data-free_shipment_virtual]').attr('data-free_shipment_virtual', $('.shpAdd2CartButton [data-current_price_value]').attr('data-current_price_value')).data('free_shipment_virtual', $('.shpAdd2CartButton [data-current_price_value]').attr('data-current_price_value'))
			shpCustom.calculateFS();
		})

		$('#product-object .single-offer').on('click', function(e) {
			$(this).addClass('active').siblings().removeClass('active');
			$('#product-object input[name=selling_plan]').val($(this).data('selling-plan-id'))
			$('.shpAdd2CartButton [data-default-price]').each(function() {
				let current_plan_price = $('#subscribe .single-offer.active .plan-price')
				$(this).html(current_plan_price.html())
				$(this).attr('data-current_price_value', current_plan_price.data('value')).data('current_price_value', current_plan_price.data('value'))
			})
			$('[data-free_shipment_virtual]').attr('data-free_shipment_virtual', $('.shpAdd2CartButton [data-current_price_value]').attr('data-current_price_value')).data('free_shipment_virtual', $('.shpAdd2CartButton [data-current_price_value]').attr('data-current_price_value'))
			shpCustom.calculateFS();
		});

		$('#subscribe-tabSelector button').on('show.bs.tab', function() {
			if ($(this).attr('id') == 'one-time-tab') {
				$('#product-object input[name=selling_plan]').val('')
				$('.shpAdd2CartButton [data-default-price]').each(function() {
					$(this).html($(this).data('default-price'))
					$(this).attr('data-current_price_value', $(this).data('default-price_value')).data('current_price_value', $(this).data('default-price_value'))
				})
			} else {
				$('#product-object input[name=selling_plan]').val($('#subscribe .single-offer.active').data('selling-plan-id'))
				$('.shpAdd2CartButton [data-default-price]').each(function() {
					let current_plan_price = $('#subscribe .single-offer.active .plan-price')
					$(this).html(current_plan_price.html())
					$(this).attr('data-current_price_value', current_plan_price.data('value')).data('current_price_value', current_plan_price.data('value'))
				})
			}
			$('[data-free_shipment_virtual]').attr('data-free_shipment_virtual', $('.shpAdd2CartButton [data-current_price_value]').attr('data-current_price_value')).data('free_shipment_virtual', $('.shpAdd2CartButton [data-current_price_value]').attr('data-current_price_value'))
			shpCustom.calculateFS();
		})

	},

	buildCartRecommended: async function() {
		let inCart = [];

		$('#header-cart [data-cart-item]').each(function() {
			if ($(this).data('cart-item-id')!="") {
				inCart.push($(this).data('cart-item-id'));
			}
		});

		let productData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));
		let recentlyViewed = [];
		if (productData) {
			productData.map(item => {
				if (!inCart.includes(item.productID)) {
					recentlyViewed.unshift(item);
				}
			});
		}

		let recentlyViewedMaxCount = $('#header-cart .recommended-product').data('last_visited_products');
		if (recentlyViewedMaxCount > 0) {
			while (recentlyViewed.length > recentlyViewedMaxCount) {
				recentlyViewed.pop();
			}
			let recentlyViewedLoaded = 0;
			$.each(recentlyViewed.reverse(), function(index, element) {
				$.ajax({
					url: shpCustom.baseURL + '/products/' + element.handle + '?sections=product-ajax_grid-item',
					type: 'GET'
				}).done(function(data) {
					let $section = $(data['product-ajax_grid-item']);
					let $productItem = $section.find('.product-item');
					if ($productItem.length) {
						let productID = $productItem.first().data('product_id');
						$('#header-cart .recommended-product .product-item[data-product_id="' + productID + '"]').addClass('d-none');
						$('#header-cart .recommended-product').prepend($section.html());
						shpCustom.init();
					}
			
				}).always(function() {
					recentlyViewedLoaded = recentlyViewedLoaded + 1;
				});
			});
		}

		
		
/**/		
	},

	ZoomyWishlistPageGridItem: function(itemID) {
		let button = $('#' + itemID + ' .zbodypimg').find('.removefromwishlist')
		if (button.length > 0) {
			//console.log('init: ' + itemID)
			$(button).html('Remove');
			$(button).removeClass(' removefromwishlist');
			$('#' + itemID + ' .zbodyaction').append($(button).detach());
		}
	},

  KlaviyoReviewsReviewAuthorProcess: function(authorElement) {
    let author = $(authorElement)
    if (author.length>0 && author.children('div.kl_reviews__review__author_avatar').length == 0) {
      let authorTXT = author.children().first().text().replace(/[^a-zA-Z0-9 ]/g, '')
      let authorWords = authorTXT.split(" ", 3);
      let authorInitials = ''
      if (authorWords.length>1) {
        for (let i = 0; i < authorWords.length; i++) {
          authorInitials += authorWords[i].substring(0,1);
        } 
      } else {
        authorInitials = authorTXT.substring(0,3)
      }
      author.prepend('<div class="kl_reviews__review__author_avatar">' + authorInitials + '</div>');
    }
  }
}

$(document).ready(function() {
  $(window).on('gridSizeChange', function(event) {
    if (event.currentSize != event.previousSize) {
      if (event.currentSize == 'xs' || event.currentSize == 'sm' || event.currentSize == 'md') {
        console.log('mobile');
        $('.top-bar').slick('slickUnfilter')
        $('.top-bar').slick('slickFilter', '.show_on-mobile')

        if ($('#shpProductVariant-container .product-content__title #ZlistWishlist').length>0) {
          let ZlistWishlist = $('#ZlistWishlist').detach();
          $('#shpProductVariant-container .product-content__price').append(ZlistWishlist);
        }

      } else {
        console.log('desktop');
        $('.top-bar').slick('slickUnfilter')
        $('.top-bar').slick('slickFilter', '.show_on-desktop')
        
        if ($('#shpProductVariant-container .product-content__price #ZlistWishlist').length>0) {
          let ZlistWishlist = $('#ZlistWishlist').detach();
          $('#shpProductVariant-container .product-content__title').append(ZlistWishlist);
        }

      }
      if ($('#ZlistWishlist').hasClass('d-none')) {
        $('#ZlistWishlist').removeClass('d-none')
      }
    }
  })

	shpCustom.init();

	// ShipModal
  $('#ShipModal').on('hidden.bs.modal', function(event) {
    shpCustom.setCookie('shipping_box',1);			// close Shipping window for current session
  })
  $('#ShipModal form').on('submit', function(event) {
    shpCustom.setCookie('shipping_box',2);			// close Shipping window for current session
  })
	$('[data-country_code_value]').on('click', function(event) {
		event.preventDefault();
		let currentShow = $(this).data('country_code_show')
		let currentValue = $(this).data('country_code_value')
		
		$(this).parents('form').find('.shpCurrentLocalization').html(currentShow);
		$(this).parents('form').find('input[name=country_code]').val(currentValue);
	});
  // if (!shpCustom.getCookie('shipping_box') && shpCustom.shpCountryISO != 'GB') {
  //   setTimeout(function(){
  //     $('#ShipModal').modal('show');
  //   }, 500);
  // }


	// collection - sort
	$('[data-sort_option]').click(function(event) {
		event.preventDefault();
		$('#filters').attr('data-collection_sortby',$(this).data('sort_option'));
		$('#filters').data('collection_sortby',$(this).data('sort_option'));

		$('[data-sort_option]').removeClass('active');
		$(this).addClass('active');
		$('#shpChoosenSortName').text($(this).data('sort_name'));

		shpCustom.reloadEnabled = true;
		shpCustom.applyFilters();
	});

	//---------------------------------------------------------------------------
	// product page
	//---------------------------------------------------------------------------
	// quantity 
	if ($('.quantity-wrapper').length > 0) {
		let quantityWrapper = $('.quantity-wrapper');
		quantityWrapper.find('button.btn-number').on('click', function(){
			let quantityValue = parseInt(quantityWrapper.find('input[name=quantity]').val());
			if ($(this).data('type') == 'plus') {
				quantityValue = quantityValue + 1
			} else if (quantityValue > 1) {
				quantityValue = quantityValue - 1
			}
			if (quantityValue > 1 ) {
				quantityWrapper.find('button.btn-number[data-type=minus]').prop('disabled',false)
			} else {
				quantityWrapper.find('button.btn-number[data-type=minus]').prop('disabled',true)
			}
			quantityWrapper.find('input[name=quantity]').val(quantityValue)
		})
	}
  $('body.product-page').on('updateVariantInfo updateProductInfo', function(event) {
    let selectedVariant = shpCustom.shpProduct.variants.find(variant => variant.id === shpCustom.shpProduct.selected_variant_id);
    // image - scroll Slick to variant image
    if (selectedVariant.featured_media && $('.thumb-image.slick-initialized').length>0) {
      $('.thumb-image .slick-slide').not('.slick-cloned').each(function () {
        if (selectedVariant.featured_media.id == $(this).data('src_id')) {
          $('.thumb-image').slick('slickGoTo', $(this).data('slick-index'), true);
        }
      });
    }
	})
	$('#pdp-back').on('click', function(event) {
		event.preventDefault();
		history.back();
	})

	//---------------------------------------------------------------------------
	// cart
	//---------------------------------------------------------------------------
	// rebuild RecommendedProducts in Cart
	$('body').on('updateCartInfo', function(event) {
		shpCustom.buildCartRecommended();	
		shpCustom.calculateFS();
	});
	shpCustom.buildCartRecommended();	
	shpCustom.calculateFS();

	// Gift note
	$('textarea[name=note][maxlength]').on('input', function() {
		var remaining = this.maxLength - this.value.length;
		$(this).siblings('small').find('.char_counter').text(remaining);
	});
	$('button.shpSaveGiftNote').on('click', function(event) {
		event.preventDefault();
		shpCustom.cartUpdate($('#collapseGiftMessage textarea[name=note]').val(), null);
    $('#collapseGiftMessage span[data-old_gift_note]').text($('#collapseGiftMessage textarea[name=note]').val());
    if ($('#collapseGiftMessage textarea[name=note]').val() != '') {
      $('.gift_prompt span').text('Edit')
    } else {
      $('.gift_prompt span').text('Add')
    }
	});
  $('#giftMessageCancelButton').on('click', function(event) {
    var $textarea = $('#collapseGiftMessage textarea[name=note]');
    $textarea.val($('#collapseGiftMessage span[data-old_gift_note]').text());
    $textarea.trigger('input');
  });

	// show Cart
	$('body').on('shpShowCart', function(event) {
		if ($('#offcanvasBag').siblings('.offcanvas-backdrop').length == 0) {
			var cartOffcanvas = new bootstrap.Offcanvas('#offcanvasBag');
			cartOffcanvas.show();
		}
	});

});

